import { render, staticRenderFns } from "./data-import-status.vue?vue&type=template&id=3a4e4a8b&scoped=true&"
import script from "./data-import-status.vue?vue&type=script&lang=ts&"
export * from "./data-import-status.vue?vue&type=script&lang=ts&"
import style0 from "./data-import-status.vue?vue&type=style&index=0&id=3a4e4a8b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e4a8b",
  null
  
)

export default component.exports